import React from 'react';
import Button from '../../components/button/Button';
import Footer from '../../components/footer/Footer';
import Navigation from '../../components/navigation/Navigation';
import './errorpage.css'

function ErrorPage() {
  return (
    <div className='error'>
      <Navigation background="theme-color" logo="https://res.cloudinary.com/emacon-production/image/upload/v1638427484/the-outlet/Artboard_7_copy_7png_j6chrh.png" />

      <div className='section_1'>
          <img src="https://res.cloudinary.com/emacon-production/image/upload/v1642668903/the-outlet/undraw_Cancel_re_ctke_fhhejh.png" alt="" />
      </div>

      <div className='section_2'>
        <h1>OOPS!</h1>
        <p>We can't seem to find what you are looking for</p>
        <div className='goHome_link-wrapper'>
            <Button 
              action="/"
              buttonColor="main-bg"
              content="GO HOME"
              borderRadius="all"
            />
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default ErrorPage;
